module.exports = __webpack_public_path__ + "static/features.88e8cbd8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features.jpg
// module id = 131
// module chunks = 35783957827783 232045937915672